import App from './App.svelte';

let app

document.addEventListener('DOMContentLoaded', e => {
	app = new App({
		target: document.getElementById('cactus')
	})

})

export default app;
